import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M15.5904 0H8.3976C7.07892 0 6 1.07978 6 2.39952V22.7954C6 23.8632 7.2947 24.4031 8.04995 23.6473L11.1548 20.5399C11.6224 20.072 12.3776 20.072 12.8452 20.5399L15.9501 23.6473C16.7053 24.4031 18 23.8632 18 22.7954V2.39952C17.988 1.07978 16.9091 0 15.5904 0ZM15.5904 19.904L14.6314 18.9442C13.013 17.3245 10.7712 17.5285 9.45255 18.8482L8.3976 19.904V3.61128C8.3976 2.95142 8.93706 2.41153 9.5964 2.41153H14.3916C15.051 2.41153 15.5904 2.95142 15.5904 3.61128V19.904Z' />
        </SvgIcon>
    );
});
